import { API } from '../../../../common/api/constants';

// Получить все Заказы по Профилю
export const GET_ALL_ORDERS = `${API}/order/carrier/{profile_id}`;

// ПОЛУЧИТЬ ВСЕ ЗАКАЗЫ ПО ФИЛЬТРУ
export const GET_FILTER_ORDERS = `${API}/order/orders/filter/{profile_id}`;

// Получить Документы по фильтру
export const GET_FILTER_DOCUMENTS = `${API}/document/documents/filter`;

// Получить Документ по ID
export const GET_DOCUMENT_BY_ID = `${API}/document/document/{document_id}`;
